module.exports = __webpack_public_path__ + "img/about-teachers-title.64792b96.svg";